<template>
    <div>
        <navigation/>

        <drop-down-header :items="dropdownItems" :callback="changePostTypes"/>

        <posts :type="listType"/>

        <centered-card v-if="noResults==='dashboard'" class="text-center">
            <h4>Oh, we are sorry! We did not find any posts for you!</h4>
            <p>Maybe you should follow a few more <router-link :to="{name:'Blogs'}">blogs</router-link>!
                The more blogs you are following, the more posts you will get on your Dashboard.</p>
        </centered-card>

        <centered-card v-if="noResults==='likes'" class="text-center">
            <h4>You do not have any favorite posts yet!</h4>
            <p>For adding posts to your favorites, just hit the <icon icon="heart"/> icon<br>
                on the lower right of a post or<br>
                on the top right of the player.</p>
        </centered-card>

    </div>
</template>

<script>

    import Navigation from '../layout/MainNavigation.vue'
    import Posts from '../posts/PostList.vue'
    import DropDownHeader from "../ui/DropDownHeader";
    import CenteredCard from "../layout/CenteredCard";
    import Icon from "../ui/Icon";


    export default {
        name: '',
        data() {
            return {
              dropdownItems: [
                {key: 'dashboard', label: 'Dashboard'},
                {key: 'likes', label: 'My Favorite Posts'},
              ],
              listType: 'dashboard',
              noResults: null
            }
        },
        metaInfo: {
          title: 'Dashboard'
        },
        mounted(){
          this.$bus.$on('postlist.noresults', (data)=>{
            this.noResults = data.type;
          })
        },
        methods: {
          changePostTypes(item){
            this.noResults = null;
            this.listType = item.key;
          }
        },
        components:{
          Icon,
          DropDownHeader,
            Navigation,
            Posts,
          CenteredCard
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/user/DashboardPage.vue